<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  height: 100vh;
  margin: 0;
  padding: 0;
  background-color: #f5f5f5; /* 添加全局背景颜色 */
}

/* 优化遮罩：更暗+轻微毛玻璃 */
.v-modal {
  background: rgba(15, 18, 22, 0.55) !important;
  backdrop-filter: saturate(140%) blur(6px);
}

/* 对话框外观细节（配合我给你的 Login.vue 的 custom-class="login-dialog"） */
.login-dialog {
  border-radius: 16px !important;
  overflow: hidden; /* 去掉对话框阴影外溢 */
}

.login-dialog .el-dialog__body {
  padding-top: 8px;
}
</style>
